import { subscribeExt } from "../modules/subscribe";

export function articlePage() {

    function fix_size($img_container) {
        var img_cl = $img_container+' img';
        var images = $(img_cl);

        images.each(setsize);

        function setsize() {
            var img = $(this),
                img_dom = img.get(0),
                container = img.parents($img_container);
            if (img_dom.complete) {
                resize();
            } else{
                img.one('load', resize);
            }

            function resize() {
                if ((container.width() / container.height()) < (img_dom.width / img_dom.height)) {
                    img.width('120%');
                    img.height('auto');
                } else {
                    img.height('120%');
                    img.width('auto');
                }
            }
        }
    }

    function ajax_jobs2_output(page, find, query)
    {
        var $parent_wrp = $('#load_more_articles').parents('.pagination-wrp').parent();
        var $articles_archive = $('.articles-archive');

        $.ajax({
            url: revent_data.ajax_url,
            type:'POST',
            data: {
                action: 'al_load_articles',
                page:   page,
                find:   find,
                query:  query,
            },
            beforeSend: function(){
                $('.load-more-articles a, .load-more-articles span').hide();
                $('.before-send-articles').show();
            },
            success:function(data){
                $('.before-send-articles').hide();
                $('.load-more-articles a, .load-more-articles span').show();

                var text = data.from + ' - ' +data.to;
                $('#load_more_articles').attr('data-articles-page', data.next_page);
                $parent_wrp.find('.from-to').text(text);
                $articles_archive.append(data.events);

                if(data.max_num_pages + 1 <= data.next_page){
                    $('#load_more_articles').hide();
                }
            }
        });
    }


    function showViewport() {
        var selector    = document.querySelector('.article-container');
        var height      = Math.max(selector.clientHeight, window.innerHeight || 0);
        $('.side-overlay').css({'height': height+'px'});

        var $window = $(window);
        var $sidebar = $("#articles-sidebar");
        var $sibling_block_height = $('.article-container');
        var $sidebarHeight = $sidebar.innerHeight();


        if($sidebarHeight < $sibling_block_height.innerHeight() - 200) {

            var $footerOffsetTop = $(".tribe-events > .container").offset().top - 50;
            var $sidebarOffset = $sidebar.offset();

            $window.scroll(function () {
                if ($window.scrollTop() > $sidebarOffset.top) {
                    $sidebar.addClass("fixed").addClass("sticky");
                } else {
                    $sidebar.removeClass("sticky");
                    $sidebar.removeClass("fixed");
                }
                if ($window.scrollTop() + $sidebarHeight > $footerOffsetTop) {
                    $sidebar.removeClass("sticky");
                    $sidebar.css({"top": -($window.scrollTop() + $sidebarHeight - $footerOffsetTop)});
                } else {
                    $sidebar.css({"top": "0",});
                }
            });
        }
    }

    function actions() {

        if($('body').hasClass('blog') || $('body').hasClass('category')) {
            subscribeExt(600);
        }

        if($('.article-container').length > 0) {
            window.onload = showViewport;
            window.onresize = showViewport;

            fix_size('a.img-wrp');

            if($('#load_more_articles').length > 0){
                $('#load_more_articles').on('click', function (e){
                    e.preventDefault();
                    var articles_page = $('#load_more_articles').attr('data-articles-page');
                    var articles_find = $('#load_more_articles').attr('data-articles-find');

                    ajax_jobs2_output(articles_page, articles_find, data_query_obj);
                });
            }
        }
    }

    actions();
}


// WEBPACK FOOTER //
// ./assets/js/pages/articles.js